module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="sorting-panel">\n    <div class="filter-search-container">\n	    <select class="filter-attribute form-control"></select>\n	    <input type="search" class="search" placeholder="Search">\n	</div>\n    <div class="sorting-tabs">\n        ';
 _.each(sortAttributeList, function (attributes, i) { ;
__p += '\n            <span ';
 if (i === 0) { ;
__p += 'class="active" ';
 } ;
__p += ' data-sort-by="' +
__e( attributes.value ) +
'">' +
__e( attributes.label ) +
'</span>\n        ';
 }); ;
__p += '\n    </div>\n</div>\n<div class="collection"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/zbone/FilteringCollectionView.tpl
// module id = 3101
// module chunks = 0